import React, { useState } from 'react'
import { SVGIcon } from '../../../wrappers/SVGIcon';
import { Icons } from '../../../../data/Assets';
import { IChanceResult } from '../../../../interfaces/services';

interface IVisaChancesAccordionProps {
    chanceResult: IChanceResult;
}

const VisaChancesAccordion = (props: IVisaChancesAccordionProps) => {
    const { chanceResult } = props;

    const [active, setActive] = useState(false);

    const handleAccordion = () => {
        setActive(!active);
    }

    const accordionContentClass = active
        ? 'immersion__visa_chances__chances__accordion__content immersion__visa_chances__chances_accordion__content_active'
        : 'immersion__visa_chances__chances__accordion__content';

    const dropDownIcon = <SVGIcon src={Icons.Chevron} rotation={active ? 180 : 0} />;

    //  empty circle icon
    const headerIcon = chanceResult.chance.includes('good')
        ? <SVGIcon src={Icons.CheckCircle} color='success' />
        : chanceResult.chance.includes('neutral')
            ? <SVGIcon src={Icons.InfoCircle} color='primary' />
            : <SVGIcon src={Icons.XCircle} color='error' />;

    return (
        <div className='immersion__visa_chances__chances__accordion'>
            <button
                className='immersion__visa_chances__chances__accordion__header'
                onClick={handleAccordion}
            >
                <p>{headerIcon} {chanceResult.title}</p>
                {dropDownIcon}
            </button>
            <div className={accordionContentClass}>
                <p>{chanceResult.description}</p>
            </div>
        </div>
    )
}
export default VisaChancesAccordion;